/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { isTrue } from "utils/empty-exists";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons";

const BulletPointStyleLink = (props) => {
    
    const { link, style } = props;
    const target = link?.is_external ? "_blank" : "_self";
    const isExternal = isTrue(link?.is_external);

    return (
        <li>
            <a
                href={link?.url}
                className={`displayLink underline ${style} `}
                target={target}
                rel='noreferrer'
            >
                {link.text}
            </a>
            {isExternal &&
                <span className='simplicity-link-icon'>&nbsp;<FontAwesomeIcon icon={faArrowUpRightFromSquare} size='1x' /></span>
            }
        </li>
    );
};

export { BulletPointStyleLink };


// const useStyles = makeStyles((theme) => ({
//     listItem: {
//         '& svg': {
//             width: 6,
//             height: 6,
//             marginRight: 12,
//             '& path': {
//                 fill: `#333`,
//             },
//         },
//     },
//     displayLink: {
//         margin: 0,
//         display: `block`,
//         color: `#0E7490`,
//         fontSize: `1rem`,
//         '&.body': {
//             fontSize: `1rem`,
//             lineHeight: 1.5,
//             fontWeight: 400,
//             color: `#0E7490`,
//         },
//         '&.h1': {
//             fontSize: `2.5rem`,
//             lineHeight: 1.5,
//             fontWeight: 700,
//             color: `#0E7490`,
//             '& svg': {
//                 width: 36,
//                 height: 36,
//                 marginLeft: 6,
//                 marginRight: 12,
//                 '& path': {
//                     fill: `#0E7490`,
//                 },
//             },
//         },
//         '&.h2': {
//             fontSize: `1.75rem`,
//             lineHeight: 1.25,
//             fontWeight: 600,
//             color: `#0E7490`,
//             '& svg': {
//                 width: 20,
//                 height: 20,
//                 marginLeft: 6,
//                 marginRight: 12,
//                 '& path': {
//                     fill: `#0E7490`,
//                 },
//             },
//         },
//         '&.h3': {
//             fontSize: `1.25rem`,
//             lineHeight: 1.25,
//             fontWeight: 500,
//             color: `#0E7490`,
//         },
//         '& svg': {
//             width: 14,
//             height: 14,
//             marginLeft: 6,
//             marginRight: 12,
//             '& path': {
//                 fill: `#0E7490`,
//             },
//         },
//     },
// }))

